export default () => ({
  init() {
    const image = this.$el;

    window.addEventListener(
      'scroll',
      () => {
        let scrolled = 1 + (window.scrollY / window.innerHeight) * 0.1,
          transformValue = 'scale(' + scrolled + ')';
        image.style.transform = transformValue;
      },
      false
    );
  },
});
